import React from "react";

import { LineInput } from "components/Inputs/LineInput";

import Waterfall from "components/Waterfall/RealityWaterfall";

import styles from "./style.module.css";

export default class CostsWaterfall extends React.PureComponent {
  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  renderRow(label, count, impact) {
    const { hideCosts, isHeader, isBlueprint } = this.props;

    return (
      <div className={styles.costRow} style={hideCosts ? { height: "25%" } : {}}>
        <div className={styles.rowLabel}>
          <div className={styles.topLabel}>
            {isBlueprint ? (
              <div className={styles.blueLabel}>{label.label}</div>
            ) : (
              <LineInput
                defaultValue={label.label}
                onChange={(val) => label.update(val)}
                isBox
                isEditable
                isHeader={isHeader}
              />
            )}
          </div>
        </div>
        <div className={styles.countInput}>
          {isBlueprint ? (
            <div className={styles.blueLabel}>{count.label}</div>
          ) : (
            <LineInput
              inputType="int"
              defaultValue={count.label}
              onChange={(val) => count.update(val)}
              isBox
              isEditable
              isHeader={isHeader}
            />
          )}
        </div>
        {"X"}
        <div className={styles.costInputN}>
          <div className={styles.impactHolder}>
            {isBlueprint ? (
              <div className={styles.blueLabel}>{impact.label}</div>
            ) : (
              <LineInput
                inputType="int"
                defaultValue={impact.label}
                onChange={(val) => impact.update(val)}
                isBox
                isEditable
                isHeader={isHeader}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { setup, showAbsTotal } = this.props;

    const {
      baselineCounts,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      currentROI,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      defaultTruePositive,
      defaultFalsePositive,
      netImpactLabel,
      blueprint,
      isShow,
      isHeader,
      isBlueprint,
      hideCosts,
      outcome,
      success,
      timePeriod,
      isRealityHammer,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateNetImpactLabel
    } = setup;

    const labelStyle = { width: "200px" };

    const waterfallBars = hideCosts
      ? [
          {
            label: truePositiveLabel,
            value: Number(truePositive)
          },
          {
            label: falsePositiveLabel,
            value: Number(falsePositive),
            color: "rgb(192, 62, 89)"
          }
        ]
      : [
          {
            label: truePositiveLabel,
            value: isRealityHammer && baselineCounts ? baselineCounts.truePositive : Number(truePositive)
          },
          {
            label: falsePositiveLabel,
            value: isRealityHammer && baselineCounts ? baselineCounts.falsePositive : Number(falsePositive),
            color: "rgb(192, 62, 89)"
          },
          {
            label: trueNegativeLabel,
            value: isRealityHammer && baselineCounts ? baselineCounts.trueNegative : Number(trueNegative),
            color: "rgb(192, 62, 89)"
          },
          {
            label: falseNegativeLabel,
            value: isRealityHammer && baselineCounts ? baselineCounts.falseNegative : Number(falseNegative)
          }
        ];

    return (
      <div className={styles.body}>
        <div className={styles.costsWaterfall}>
          {truePositive + falsePositive + trueNegative + falseNegative !== 0 && (
            <Waterfall bars={waterfallBars} totalLabel={netImpactLabel} roundTotal showTotalVal />
          )}
        </div>
      </div>
    );
  }
}
